import { functions } from 'shared/util';
import { bindThis } from './bindThis';

/**
 * Fixes "this" in all methods in a class. NOTE that if you're using this in a decorator chain it's probably best left
 * till last to ensure binding occurs as expected.
 * @param target
 * @returns {*}
 */
export function bindAll (target) {
  functions(target.prototype).forEach(key => {
    let descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

    // Only methods need binding
    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, bindThis(target, key, descriptor));
    }
  });

  return target;
}



// WEBPACK FOOTER //
// ./src/shared/decorators/bindAll.js